export enum ExpenditureType {
  CONTRACT = 'Contract',
  UTILITIES = 'Utilities',
  GROCERIES = 'Groceries',
  SUBSCRIPTIONS = 'Subscriptions',
  FUEL = 'Fuel',
  OTHER = 'Other'
}
